import { Injectable } from '@angular/core';
import { OrgQuery } from '@y42/org/state';
import { OrgSpaceQuery } from '@y42/org-space/state';
import { UserQuery } from '@y42/user/state';
import { UserTrackingPreferencesServiceLegacy } from '@y42/user-tracking-legacy';

@Injectable({ providedIn: 'root' })
export class Y42UserTrackingPreferencesServiceLegacy extends UserTrackingPreferencesServiceLegacy {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly orgQuery: OrgQuery,
    private readonly spaceQuery: OrgSpaceQuery,
  ) {
    super();
  }

  getUser(): { id: string; email: string } | null {
    const user = this.userQuery.getActiveUser();
    return user.id ? { id: `${user.id}`, email: user.email } : null;
  }

  getBaseProperties(): Array<{ key: string; value: string }> {
    const activeUser = this.userQuery.getActiveUser();
    const activeOrg = this.orgQuery.getActive() || null;
    const activeSpace = this.spaceQuery.getActive() || null;

    return [
      { key: 'organization_name', value: activeOrg?.name || '' },
      { key: 'organization_slug', value: activeOrg?.slug || '' },
      { key: 'customer_email', value: activeUser.email || '' },
      { key: 'customer_id', value: activeUser.id.toString() || '' },
      { key: 'timestamp', value: new Date().toISOString() },
      { key: 'space_name', value: activeSpace?.name || '' },
    ];
  }

  getBaseContext() {
    const orgId = this.orgQuery.getActiveId();
    return orgId ? { groupId: `${orgId}` } : null;
  }
}
